// Import all locale files statically
import enGB from '@/locales/en-GB.json';
import deDE from '@/locales/de-DE.json';
import deAT from '@/locales/de-AT.json';
import frFR from '@/locales/fr-FR.json';
import itIT from '@/locales/it-IT.json';
import esES from '@/locales/es-ES.json';
import nlNL from '@/locales/nl-NL.json';
import ptPT from '@/locales/pt-PT.json';
import huHU from '@/locales/hu-HU.json';
import daDK from '@/locales/da-DK.json';

// Type for translation messages (flat key-value structure)
export type TranslationMessages = Record<string, string | Record<string, string>>;

// Map of all available translations
const translations: Record<string, TranslationMessages> = {
  'en-GB': enGB as TranslationMessages,
  'de-DE': deDE as TranslationMessages,
  'de-AT': deAT as TranslationMessages,
  'fr-FR': frFR as TranslationMessages,
  'it-IT': itIT as TranslationMessages,
  'es-ES': esES as TranslationMessages,
  'nl-NL': nlNL as TranslationMessages,
  'pt-PT': ptPT as TranslationMessages,
  'hu-HU': huHU as TranslationMessages,
  'da-DK': daDK as TranslationMessages,
};

// Default fallback locale
const DEFAULT_LOCALE = 'en-GB';

/**
 * Load translations for a given locale.
 * Falls back to en-GB if the requested locale is not available.
 *
 * @param locale - The locale string (e.g., 'en-GB', 'de-DE')
 * @returns The translation messages for the locale
 */
export const loadTranslations = (locale: string): TranslationMessages => {
  const normalizedLocale = locale.replace('_', '-');

  if (translations[normalizedLocale]) {
    return translations[normalizedLocale];
  }

  // If exact locale not found, return default (en-GB)
  return translations[DEFAULT_LOCALE];
};
